__webpack_require__.p = "/RestaurantTemplate/";